import { makeVar } from '@apollo/client'

export interface AnalyticsIdentity {
  kind: 'guest' | 'user'
  id: string
}

/**
 * Who analytics requests go out as (FE-321): the signed-in user or the guest
 * session, both by cookie. `null` until `me` and the guest session answer —
 * the backend ignores a request with neither, so nothing is sent before.
 */
export const analyticsIdentityVar = makeVar<AnalyticsIdentity | null>(null)

export const identityKey = ({ kind, id }: AnalyticsIdentity) => `${kind}:${id}`
